import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const CmsBreadcrumbStyles = makeStyles((theme) => ({
  breadcrumbContainer: {
    [theme.breakpoints.down("lg")]: {},
    [theme.breakpoints.up("md")]: {}
  },
  breadcrumbLink: {
    marginTop: "1rem",
    display: "inline-flex",
    alignItems: "center",
    cursor: "pointer",
    textDecoration: "none",
    [theme.breakpoints.down("lg")]: {},
    [theme.breakpoints.between("md", "xl")]: {},
    [theme.breakpoints.up("lg")]: {}
  },
  breadcrumbText: {
    color: COLORS.DARK_GRAY,
    marginRight: "1rem",
    lineHeight: 1
  },
  breadcrumbIcon: {
    color: COLORS.DARK_GRAY,
    display: "flex",
    alignItems: "center",
    fontSize: 20
  }
}));

export default CmsBreadcrumbStyles;
